module.exports = __webpack_public_path__ + "img/calendar.4d2a2b83.svg";